export class SocietyDetails {
  iSCategoryid: number = 0;
  iSKindid: number = 0;
  iSTypeid: number = 0;
  sSocietyName: string = '';
  iAreaOperation: number = 0;
  iDivisionId: number = 0;
  iDistrictId: number = 0;
  iBlockid: number = 0;
  iCircleid: number = 0;
  iPanchayat: number = 0;
  iVillage: number = 0;
  iLocalBody: number = 0;
  iWard: number = 0;
  iSubCircleid: number = 0;
  sAddress1: string = '';
  objective: any;
  sdivisionname: string = '';
  sdistrictname: string = '';
  scirclename: string = '';
  sblockname: string = '';
  spanchayatname: string = '';
  svillagename: string = '';
  scategoryname: string = '';
  ssocietykindname: string = '';
  ssocietytypename: string = '';
  sareaoperationname: string = '';
  sPinCode: string = '';
  isSendBack: number = 0;
  isWaterBody: string = '';
  iWaterType: number = 0;
  isAffiliated: string = '';
  sAffiliatedlevel: string = '';
  sAffiliatedName: string = '';
}
export class SocietyMember {
  iMemId: number = 0;
  sMemName: string = '';
  sMemAge: string = '';
  iGenderid: number = 0;
  iMemOccupation: number = 0;
  iMaritalSta: number = 0;
  sMemHusName: number = 0;
  sAadharid: string = '';
  midentitynumber: string = '';
  sUploadAadharCardPath: string = '';
  iMemTypeId: number = 0;
  sMemShipFee: string = '';
  sAdd1: string = '';
  sAdd2: string = '';
  iMemDesId: number = 0;
  iSocietyDetailsId: number = 0;
  sSocietyRegistrationNo: string = '';
  iMemCastid: number = 0;
  sMemShareCaptial: string = '';
  iMemberShipId: number = 0;
  file: string = '';
  fileName: string = '';
  sMemShareAmount: string = '';
  sGender: string = '';
  sOccupation: string = '';
  sMemTypeName: string = '';
  sMemberCast: string = '';
  sMembershiptypename: string = '';
  sMaritalStatus: string = '';
  iSocietyId: number = 0;
}

export class SocietyLaws {
  iSocietyByLawsid: number = 0;
  iSocietyDetailsid: number = 0;
  sUploadbylawsPath: string = '';
  dtDateAGM: string = '';
  sImportantPoint: number = 0;
  file: string = '';
  fileName: string = '';
  iSocietyId: number = 0;
}
export class ElectionDetails {
  iElectionid: number = 0;
  dtElectiondate: string = '';
  sElectionTerms: string = '';
  sElectionRemark: string = '';
  iSocietyDetailsid: number = 0;
}

export class SocietyProceeding {
  iSocietyProceedingid: number = 0;
  dtSelectDate: string = '';
  sDocName: string = '';
  sDocPath: string = '';
  sDocDescription: string = '';
  iSocietyDetailsid: number = 0;
  file: string = '';
  fileName: string = '';
  iSocietyId: number = 0;
}
export class OtherDocuments {
  iSocietOtherDocid: number = 0;
  dtDocDate: string = '';
  sDocName: string = '';
  sDocUploadPath: string = '';
  sDocRemark: string = '';
  iSocietyDetailsId: number = 0;
  file: string = '';
  fileName: string = '';
}
export class RegistrationFee {
  iSocietyFeeid: number = 0;
  dtSubmitDate: string = '';
  sEchaalanNumber: string = '';
  dFeeAmount: string = '';
  sUploadRecPath: string = '';
  sRemark: string = '';
  iSocietyDetailid: number = 0;
  file: string = '';
  fileName: string = '';
}
export class BankDetails {
  iSocietyBankid: number = 0;
  sAccountNo: string = '';
  sBankName: string = '';
  sIFSCCode: string = '';
  sBankLocation: string = '';
  sCurrentBalance: string = '';
  sCurrentBalanceReceipt: string = '';
  sPassbookimg: string = '';
  dtCtedate: string = '';
  iUserid: number = 0;
  iSocietyDetailsid: number = 0;
  file1: string = '';
  file2: string = '';
  fileName1: string = '';
  fileName2: string = '';
}
export class Comments {
  iRoleId: number = 0;
  iStepsid: number = 0;
  IsComplied: number = 0;
  sComments: string = '';
  iSocietyDetailsid: number = 0;
}
export class ChangeState {
  Action: string = '';
  iSocietyDetailsid: number = 0;
  iUserid: number = 0;
  sRemark: string = '';
  sUploadFilePath: string = '';
  file: string = '';
  fileExtension: string = '';
  fileName: string = '';
}
export class CheckListImage{
  id: number = 0;
  file: string = '';
  fileExtension: string = '';
  fileName: string = '';
}